import React, { useEffect, useState } from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { provinciasPorComunidad, provincias } from '../../../zoneData';


const ProvinciasSelect = ({ comunidadesSeleccionadas, provinciasSeleccionadas, onSelectProvincias }) => {
  const [provinciasFiltradas, setProvinciasFiltradas] = useState([]);

  useEffect(() => {
    // Lógica para filtrar provincias según las comunidades seleccionadas
    const provinciasDisponibles = obtenerProvinciasDisponibles(comunidadesSeleccionadas);
    setProvinciasFiltradas(provinciasDisponibles);
  }, [comunidadesSeleccionadas]);

  const obtenerProvinciasDisponibles = (comunidades) => {
    // Si no hay comunidades seleccionadas, mostrar todas las provincias
    if (!comunidades || comunidades.length === 0) {
      return provincias;
    }
    
    // Filtrar las provincias basadas en las comunidades seleccionadas
    const provinciasFiltradas = comunidades.reduce((provincias, comunidad) => {
      return provincias.concat(provinciasPorComunidad[comunidad] || []);
    }, []);
    return Array.from(new Set(provinciasFiltradas));
  };

  return (
    <FormControl fullWidth>
      <InputLabel id="provincias-label">Provincias</InputLabel>
      <Select
        labelId="provincias-label"
        id="provincias"
        multiple
        value={provinciasSeleccionadas}
        onChange={(e) => onSelectProvincias(e.target.value)}
        label="Provincias"
      >
        {provinciasFiltradas.map((provincia) => (
          <MenuItem key={provincia} value={provincia}>
            {provincia}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default ProvinciasSelect;
